import { EventEmitter } from 'events';
import assign from 'object-assign';
import _ from 'underscore';
import i18next from 'i18next';
import AdminAppDispatcher from '../dispatcher/AdminAppDispatcher';
import AdminConstants from '../constants/AdminConstants';
import TimelineUtils from '../utils/timeline/TimelineUtils';
import ShipmentCollection from './entities/shipment-collection';
import formatMoney from 'utils/formatters/Money';
const ActionTypes = AdminConstants.ActionTypes;
const CHANGE_EVENT = 'change';
const AUDITS_CHANGE_EVENT = 'auditsChange';
const BOOKING_CHANGE_EVENT = 'bookingChange';
const BULK_UPDATE_CHANGE_EVENT = 'bulkUpdateChange';
const ADD_ACCESSORIAL_CHANGE_EVENT = 'addAccessorialChange';
const BULK_SHIPMENT_UPDATE_CHANGE_EVENT = 'bulkShipmentUpdateChange';
const BULK_SHIPMENT_UPDATE_DATES_SUCCESS_EVENT = 'bulkShipmentUpdateDatesSuccess';
const BULK_SHIPMENT_UPDATE_NOTES_SUCCESS_EVENT = 'bulkShipmentUpdateNotesSuccess';
const SHIPMENT_BULK_TRANSITION_SUCCESS_EVENT = 'shipmentBulkTransitionSuccess';
const ADJUSTMENTS_UPDATE_EVENT = 'adjustmentsChange';
const DELIVERY_ORDER_STATUS_UPDATE_EVENT = 'deliveryOrderStatusUpdateEvent';
const RERATE_COST_EVENT = 'rerateCostEvent';
const shipments = new ShipmentCollection([]);
const messages = {};
let createdOffer = null;
let distance = null;
let share_result = null;
let shipmentAudit = null;
let bookingErrorMessage = null;
let updatedShipperJobs = null;
let bulkUpdateShipments = [];
let addAccessorialError = null;
let bulkUpdateResult = null;
let bulkShipmentUpdateResult = null;
let deliveryOrderUpdateStatusResult = null;
const ShipmentStore = assign({}, EventEmitter.prototype, {
    emitChange() {
        this.emit(CHANGE_EVENT);
    },
    emitBookingChange() {
        this.emit(BOOKING_CHANGE_EVENT);
    },
    emitAddAccessorialChange() {
        this.emit(ADD_ACCESSORIAL_CHANGE_EVENT);
    },
    emitBulkUpdateChange() {
        this.emit(BULK_UPDATE_CHANGE_EVENT);
    },
    emitBulkShipmentUpdateChange() {
        this.emit(BULK_SHIPMENT_UPDATE_CHANGE_EVENT);
    },
    emitBulkShipmentDatesUpdateChange() {
        this.emit(BULK_SHIPMENT_UPDATE_DATES_SUCCESS_EVENT);
    },
    emitBulkShipmentNotesUpdateChange() {
        this.emit(BULK_SHIPMENT_UPDATE_NOTES_SUCCESS_EVENT);
    },
    emitShipmentBulkTransitionSuccessChange() {
        this.emit(SHIPMENT_BULK_TRANSITION_SUCCESS_EVENT);
    },
    emitAdjustmentsChange() {
        this.emit(ADJUSTMENTS_UPDATE_EVENT);
    },
    emitCostRerateEvent() {
        this.emit(RERATE_COST_EVENT);
    },
    emitShipmentAuditsChange() {
        this.emit(AUDITS_CHANGE_EVENT);
    },
    emitDeliveryOrderStatusChange() {
        this.emit(DELIVERY_ORDER_STATUS_UPDATE_EVENT);
    },
    clearAddAccessorialError() {
        addAccessorialError = null;
    },
    setAddAccessorialError(error) {
        addAccessorialError = error;
    },
    getAddAccessorialError() {
        return addAccessorialError;
    },
    getShareResult() {
        return share_result;
    },
    getBulkUpdateResult() {
        return bulkUpdateResult;
    },
    addChangeListener(callback) {
        this.on(CHANGE_EVENT, callback);
    },
    removeChangeListener(callback) {
        this.removeListener(CHANGE_EVENT, callback);
    },
    getUpdatedShipperJobs() {
        return updatedShipperJobs;
    },
    addBookingChangeListener(callback) {
        this.on(BOOKING_CHANGE_EVENT, callback);
    },
    addAccessorialChangeListener(callback) {
        this.on(ADD_ACCESSORIAL_CHANGE_EVENT, callback);
    },
    removeAccessorialChangeListener(callback) {
        this.removeListener(ADD_ACCESSORIAL_CHANGE_EVENT, callback);
    },
    addBulkUpdateChangeListener(callback) {
        this.on(BULK_UPDATE_CHANGE_EVENT, callback);
    },
    addBulkShipmentUpdateChangeListener(callback) {
        this.on(BULK_SHIPMENT_UPDATE_CHANGE_EVENT, callback);
    },
    addBulkShipmentDatesUpdateChangeListener(callback) {
        this.on(BULK_SHIPMENT_UPDATE_DATES_SUCCESS_EVENT, callback);
    },
    removeBulkShipmentDatesUpdateChangeListener(callback) {
        this.removeListener(BULK_SHIPMENT_UPDATE_DATES_SUCCESS_EVENT, callback);
    },
    addBulkShipmentNotesUpdateChangeListener(callback) {
        this.on(BULK_SHIPMENT_UPDATE_NOTES_SUCCESS_EVENT, callback);
    },
    removeBulkShipmentNotesUpdateChangeListener(callback) {
        this.removeListener(BULK_SHIPMENT_UPDATE_NOTES_SUCCESS_EVENT, callback);
    },
    addShipmentBulkTransitionSuccessChangeListener(callback) {
        this.on(SHIPMENT_BULK_TRANSITION_SUCCESS_EVENT, callback);
    },
    removeShipmentBulkTransitionSuccessChangeListener(callback) {
        this.removeListener(SHIPMENT_BULK_TRANSITION_SUCCESS_EVENT, callback);
    },
    addAdjustmentsChangeListener(callback) {
        this.on(ADJUSTMENTS_UPDATE_EVENT, callback);
    },
    addRerateCostChangeListener(callback) {
        this.on(RERATE_COST_EVENT, callback);
    },
    addShipmentAuditsChangeListener(callback) {
        this.on(AUDITS_CHANGE_EVENT, callback);
    },
    addDeliveryOrderStatusUpdateChangeListener(callback) {
        this.on(DELIVERY_ORDER_STATUS_UPDATE_EVENT, callback);
    },
    removeShipmentAuditsChangeListener(callback) {
        this.removeListener(AUDITS_CHANGE_EVENT, callback);
    },
    removeBookingChangeListener(callback) {
        this.removeListener(BOOKING_CHANGE_EVENT, callback);
    },
    // This function deals with stops on the shipment, not neccessarily the shipment attributes itself
    removeBulkUpdateChangeListener(callback) {
        this.removeListener(BULK_UPDATE_CHANGE_EVENT, callback);
    },
    removeBulkShipmentUpdateChangeListener(callback) {
        this.removeListener(BULK_SHIPMENT_UPDATE_CHANGE_EVENT, callback);
    },
    removeAdjustmentsChangeListener(callback) {
        this.removeListener(ADJUSTMENTS_UPDATE_EVENT, callback);
    },
    removeDeliveryOrderStatusUpdateChangeListener(callback) {
        this.removeListener(DELIVERY_ORDER_STATUS_UPDATE_EVENT, callback);
    },
    getShipments() {
        return shipments.toJSON();
    },
    getShipment(id) {
        const shipment = shipments.get(id);
        if (shipment)
            return shipment.toJSON();
        return {};
    },
    getMessages(id) {
        return messages[id] || [];
    },
    getCreatedOffer: function () {
        return createdOffer;
    },
    getBookingErrorMessage: function () {
        return bookingErrorMessage;
    },
    clearCreatedOffer() {
        createdOffer = null;
    },
    onReceiveCreatedOffer(action) {
        bookingErrorMessage = null;
        createdOffer = action.offer;
    },
    getShipmentAudit() {
        return shipmentAudit;
    },
    onCreateOfferFail(message) {
        bookingErrorMessage = message;
        this.clearCreatedOffer();
    },
    getUnusedTimelineStatuses(id) {
        const shipment = shipments.get(id).toJSON();
        const result = _(TimelineUtils.allTimelineStatuses).filter((it) => !_.values(shipment.timeline).find((item) => item.status.code === it.code));
        return result;
    },
    getDistance() {
        return distance;
    },
    updateShipments(shipmentsToUpdate) {
        if (shipmentsToUpdate) {
            return shipmentsToUpdate.forEach((shipment) => {
                const shipmentToUpdate = shipments.get(shipment._id);
                if (shipmentToUpdate) {
                    // Object.assign(shipmentToUpdate, shipment, ...shipments);
                    shipments.remove(shipmentToUpdate);
                    shipments.add(shipment);
                }
                else {
                    shipments.add(shipment);
                }
                // ShipmentStore.emitChange();
            });
        }
    },
    setBulkUpdateResult(action, updated) {
        const { successes, errors, error } = updated;
        ShipmentStore.updateShipments(successes);
        bulkUpdateResult = {
            successes,
            errors: !Array.isArray(errors) ? [error] : errors,
            action,
        };
        this.emitBulkUpdateChange();
    },
    setShipmentsForBulkUpdates(data) {
        bulkUpdateShipments = data;
    },
    getShipmentsForBulkUpdate() {
        return bulkUpdateShipments;
    },
    setBulkShipmentUpdateResult(updated) {
        const { successes, errors } = updated;
        bulkShipmentUpdateResult = {
            successes,
            errors,
        };
        this.emitBulkShipmentUpdateChange();
    },
    getBulkShipmentUpdateResult() {
        return bulkShipmentUpdateResult;
    },
    getDeliveryOrderUpdateStatus() {
        return deliveryOrderUpdateStatusResult;
    },
    setDeliveryOrderStatusUpdateResult(response) {
        const { entity, request } = response;
        const action = JSON.parse(request.entity);
        deliveryOrderUpdateStatusResult = {
            action: action.status,
            status: entity.success || false,
        };
        this.emitDeliveryOrderStatusChange();
    },
});
ShipmentStore.dispatchToken = AdminAppDispatcher.register((payload) => {
    var _a;
    const action = payload.action;
    switch (action.type) {
        case ActionTypes.ADD_ACCESSORIAL_FAIL:
            ShipmentStore.setAddAccessorialError(action.response.entity);
            ShipmentStore.emitAddAccessorialChange();
            break;
        case ActionTypes.ADD_ACCESSORIAL_SUCCESS:
            ShipmentStore.clearAddAccessorialError();
            ShipmentStore.emitAddAccessorialChange();
            break;
        case ActionTypes.GENERATE_DELIVERY_ORDER_REQUEST:
        case ActionTypes.RECEIVE_SHIPMENT_STOP_COMPLETE_SUCCESS:
        case ActionTypes.RECEIVE_SHIPMENT: {
            if (action.shipment) {
                const shipmentToUpdate = shipments.get(action.shipment._id);
                if (shipmentToUpdate)
                    shipments.remove(shipmentToUpdate);
                if (shipmentToUpdate &&
                    shipmentToUpdate.get('cost') !== action.shipment.cost) {
                    const message = `The base payable rate for this shipment has changed from ${formatMoney(shipmentToUpdate.get('cost'), action.shipment.currency)} to ${formatMoney(action.shipment.cost, action.shipment.currency)}`;
                    messages[action.shipment._id] = (messages[action.shipment._id] || []).concat([message]);
                }
                shipments.add(action.shipment);
                ShipmentStore.emitChange();
            }
            break;
        }
        case ActionTypes.RECEIVE_MASS_UPDATE_SUCCESS:
            ShipmentStore.setBulkUpdateResult(action.stopAction, action.response);
            break;
        case ActionTypes.RECEIVE_BULK_TRANSITION_SUCCESS:
            ShipmentStore.setBulkShipmentUpdateResult(action.response);
            ShipmentStore.emitShipmentBulkTransitionSuccessChange();
            break;
        case ActionTypes.BULK_UPDATE_CARRIER_COSTS_SUCCESS:
            ShipmentStore.setBulkShipmentUpdateResult(action.response);
            break;
        case ActionTypes.RECEIVE_SHIPMENT_CLONE_SUCCESS: {
            const cloneIds = (_a = action === null || action === void 0 ? void 0 : action.clones) === null || _a === void 0 ? void 0 : _a.map((clone) => `[${clone === null || clone === void 0 ? void 0 : clone.shipment_id}](/shipments/${clone === null || clone === void 0 ? void 0 : clone._id})`).join(', ');
            const message = i18next.t('MULTIPLE_SHIPMENT_CLONED_SUCCESS_MSG', {
                cloneIds: cloneIds,
            });
            messages[action.shipment._id] = (messages[action.shipment._id] || []).concat([message]);
            ShipmentStore.emitChange();
            break;
        }
        case ActionTypes.RECEIVE_ALL_SHIPMENTS: {
            const incomingShipments = action.shipments.items;
            shipments.reset(incomingShipments);
            ShipmentStore.emitChange();
            break;
        }
        case ActionTypes.RECEIVE_SHIPMENT_UPDATE: {
            const shipmentToUpdate = shipments.get(action.shipment._id);
            shipments.remove(shipmentToUpdate);
            shipments.add(action.shipment);
            ShipmentStore.emitChange();
            break;
        }
        case ActionTypes.RECEIVE_CREATED_OFFER:
            ShipmentStore.onReceiveCreatedOffer(action);
            ShipmentStore.emitBookingChange();
            break;
        case ActionTypes.CREATE_OFFER_FAIL:
            ShipmentStore.onCreateOfferFail(action.message);
            ShipmentStore.emitBookingChange();
            break;
        case ActionTypes.CLEAR_ALL_MESSAGES: {
            delete messages[action.id];
            ShipmentStore.emitChange();
            break;
        }
        case ActionTypes.CLEAR_MESSAGE: {
            if (messages[action.id]) {
                messages[action.id].splice(action.index, 1);
                ShipmentStore.emitChange();
            }
            break;
        }
        case ActionTypes.RECEIVE_SHIPMENT_DISTANCE_SUCCESS: {
            distance = action.data.distance;
            ShipmentStore.emitChange();
            break;
        }
        case ActionTypes.RECEIVE_SHARE_SHIPMENT: {
            share_result = action.isSuccessful;
            ShipmentStore.emitChange();
            break;
        }
        case ActionTypes.RECEIVE_SHIPMENT_AUDIT: {
            shipmentAudit = action.audits;
            ShipmentStore.emitShipmentAuditsChange();
            break;
        }
        case ActionTypes.RECEIVE_UPDATE_JOBS_SHIPPER_SUCCESS: {
            updatedShipperJobs = action.jobs;
            ShipmentStore.emitChange();
            break;
        }
        case ActionTypes.RECEIVE_UPDATE_JOBS_CONSIGNEE_SUCCESS: {
            updatedShipperJobs = action.jobs;
            ShipmentStore.emitChange();
            break;
        }
        case ActionTypes.UPDATE_SHIPMENT_ADJUSTMENTS_SUCCESS: {
            ShipmentStore.emitAdjustmentsChange();
            break;
        }
        case ActionTypes.GET_SHIPMENTS_BY_ID:
            ShipmentStore.setShipmentsForBulkUpdates(action.data);
            ShipmentStore.emitChange();
            break;
        case ActionTypes.UPDATE_DELIVERY_ORDER_STATUS_SUCCESS:
            ShipmentStore.setDeliveryOrderStatusUpdateResult(action.response);
            break;
        case ActionTypes.RERATE_SHIPMENT_COSTS_SUCCESS: {
            const shipmentToUpdate = shipments.get(action.response.shipment._id);
            shipments.remove(shipmentToUpdate);
            shipments.add(action.response.shipment);
            ShipmentStore.emitChange();
            break;
        }
        case ActionTypes.BULK_UPDATE_DATES_SUCCESS: {
            ShipmentStore.emitBulkShipmentDatesUpdateChange();
            break;
        }
        case ActionTypes.BULK_UPDATE_NOTES_SUCCESS: {
            ShipmentStore.emitBulkShipmentDatesUpdateChange();
            break;
        }
        case ActionTypes.BULK_UPDATE_SPECIAL_INSTRUCTIONS_SUCCESS: {
            ShipmentStore.emitBulkShipmentDatesUpdateChange();
            break;
        }
        case ActionTypes.BULK_UPDATE_SHIPMENTS_SUCCESS: {
            ShipmentStore.emitBulkShipmentDatesUpdateChange();
            break;
        }
        case ActionTypes.BULK_UPDATE_REFERENCE_SUCCESS: {
            ShipmentStore.emitBulkShipmentDatesUpdateChange();
            break;
        }
        case ActionTypes.BULK_UPDATE_REFERENCE_FAIL: {
            ShipmentStore.emitBulkShipmentDatesUpdateChange();
            break;
        }
        default:
            break;
    }
});
export default ShipmentStore;
